import React from 'react';
import { SectionOne } from './SectionOne';
import { SectionTwo } from './SectionTwo';
const BACKGROUND_IMAGE = "/hf_20260618_151755_c4bf5388-ad3d-4ace-87d1-d24cf4e8fb9c_1_(1).png";
export function NovaSection() {
  return <div id="nova-container" className="relative font-sans text-white nova-selection bg-black" data-id="element-4026" data-mp="2ciq5t2jo2au8">
      {/* Sticky container for the background image */}
      <div className="sticky top-0 h-screen w-full overflow-hidden" data-id="element-4027" data-mp="23j356iyrh928">
        <div className="absolute inset-0 -z-10 bg-[#0a0a0a]" data-id="element-4028" data-mp="23kebapfoiswi">
          <img src={BACKGROUND_IMAGE} alt="Giga connected to hundreds of tools, responding to a request in a Slack channel" className="absolute inset-0 h-full w-full object-cover" data-id="element-4029" data-mp="1ys3dbs4i1h6l" />
          {/* Dark scrim keeps the overlaid headline and CTA legible over the
           busy connection graph. */}
          <div className="absolute inset-0 bg-black/30" data-id="element-4030" data-mp="1ksv92kthbivj" />
        </div>
      </div>

      {/* Content overlays the sticky video */}
      <div className="relative z-10 -mt-[100vh]" data-id="element-4031" data-mp="1fu0opefv5m9b">
        <SectionOne data-id="element-4032" data-mp="31vri68di5rxb" />
        <div aria-hidden className="h-[80vh]" data-id="element-4033" data-mp="31v89li9qsfvy" />
        <SectionTwo data-id="element-4034" data-mp="31uges9nyym6q" />
      </div>
    </div>;
}